import { toJalaali } from "jalaali-js";
export const GroupBy = (array: any[], callback: (arg0: any) => any) => {
  return array.reduce(function (store, item) {
    var key = callback(item);
    var value = store[key] || [];
    store[key] = value.concat([item]);
    return store;
  }, []);
};

export const objectToFormData = (data: Object) => {
  const myFormData = new FormData();

  for (const key in data) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const value = data[key];

    if (typeof value === "object" && !Array.isArray(value)) {
      // For nested objects
      for (const nestedKey in value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        myFormData.append(`${key}[${nestedKey}]`, value[nestedKey]);
      }
    } else if (Array.isArray(value)) {
      // For arrays
      for (const item of value) {
        myFormData.append(key, item);
      }
    } else {
      // For primitive types
      myFormData.append(key, value);
    }
  }

  return myFormData;
};

export function convertToFormData2(
  obj: any,
  parentKey = "",
  formData = new FormData()
) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];
      let fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value && typeof value === "object" && !Array.isArray(value)) {
        convertToFormData2(value, fullKey, formData);
      } else {
        formData.append(fullKey, value);
      }
    }
  }
  return formData;
}

export const splitPelak = (pelak: string) => {
  const firstTowDigits = pelak.slice(4, 6);
  const lastThiredDigits = pelak.slice(0, 3);
  const alpha = pelak.slice(3, 4);
  const licensePlateSerial = pelak.split(" ")[2];

  return {
    firstTowDigits,
    lastThiredDigits,
    alpha,
    licensePlateSerial,
  };
};

export const convertToJalali = (isoDate: string): string => {
  if (isoDate?.length) {
    const date = new Date(isoDate);
    const jalaliDate = toJalaali(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );

    // Extract time
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds} ${jalaliDate.jy}/${jalaliDate.jm}/${jalaliDate.jd}`;
  } else {
    return "-/-/-";
  }
};

export function convertToPersianDate(jalaaliDate: string) {
  const [year, month, day] = jalaaliDate.split("/").map(Number);

  const persianMonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const persianMonth = persianMonths[month - 1];
  return `${day} ${persianMonth}`;
}

export const PreventInputAlpha = (
  e: React.ChangeEvent<HTMLInputElement>,
  formikHandleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  const value = e.target.value;
  const persianCharRegex = /^[^\u0600-\u06FFa-zA-Z]*$/;
  if (persianCharRegex.test(value)) {
    formikHandleChange(e); // Only call Formik's handleChange if no Persian characters are found
  }
};

export function flattenObject(
  obj: Record<string, any>,
  parentKey = ""
): Record<string, any> {
  const result: Record<string, any> = {};

  // تابع کمکی برای تشخیص تاریخ معتبر
  function isValidISODate(value: string): boolean {
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/; // بررسی فرمت ISO
    return isoDateRegex.test(value) && !isNaN(Date.parse(value));
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = parentKey
        ? `${parentKey}${key.charAt(0).toUpperCase() + key.slice(1)}`
        : key.charAt(0).toUpperCase() + key.slice(1);

      if (Array.isArray(obj[key])) {
        // اگر مقدار آرایه باشد، آن را نادیده می‌گیریم
        continue;
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        // اگر آبجکت تو در تو باشد، به صورت بازگشتی پردازش می‌کنیم
        Object.assign(result, flattenObject(obj[key], newKey));
      } else if (typeof obj[key] === "string" && isValidISODate(obj[key])) {
        // اگر مقدار تاریخ معتبر باشد، آن را به جلالی تبدیل می‌کنیم
        result[newKey] = convertToJalali(obj[key]);
      } else {
        // اگر مقدار نهایی باشد، اضافه می‌کنیم
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}
